export default {
  printPublicationTypeBoxFlag: false,
  emailElectronicTypeBoxFlag: false,
  socialNetworkNameBoxFlag: false,
  dashboardFlag: false,
  DashboardDirectMailOptionBoxFlagState: false,
  DashboardDirectMailEmailOptionBoxFlagState: false,
  isCreditOptionOn: false,
  isBankingOptionOn: false,
  isAutomativeOptionOn: false,
  isTravelOptionOn: false,
  isBankingSectorOptionOn: false,
  isEnergyOptionOn: false,
  isHRPayrollOptionOn: false,
  isInsuranceOptionOn: false,
  isInvestmentsOptionOn: false,
  isMortgageOptionOn: false,
  isPharmaceuticalOptionOn: false,
  isEstateOptionOn: false,
  isRetailOptionOn: false,
  isShippingOptionOn: false,
  isTelecomOptionOn: false,
  directMailDeliveryBoxFlag: false,
  selectedData: {
    mChannelID: [],
    sectorID: [],
    mPanelID: [],
  },
  additionalSelectedData: {},
  lastSearchTriggerred: false,
};
